import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { BuildingType } from "../../data";

@Component({
    selector: "[app-roof]",
    templateUrl: "./roof.component.html",
    styleUrls: ["./roof.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofComponent {
  public type = input<BuildingType>(BuildingType.Catalog);
  public buildingType = BuildingType;

  private readonly roofPaths = {
    outer: {
      [BuildingType.Library]: "M152.161 174.681 L20.6152 101.886 L198.299 0.81543 L329.833 73.6091 L152.161 174.681Z",
      [BuildingType.Dummy]: "M0 58.702L97.6265 0.416504L195.247 58.702L97.3795 117.214L0 58.702Z",
      [BuildingType.Management]: "M138 1 L231 60 L96 144 L3 85 L138 1 Z",
      [BuildingType.Tracker]: "M0 90 L114 158 L187 114 L73 47 L0 90 Z",
      [BuildingType.Monitoring_Reporting]: "M0 101 L178 208 L299 135 L122 28 L0 101 Z",
      [BuildingType.Marketplace]: "M310 66 L108 186 L1 122 L201 1 L310 66 Z",
      [BuildingType.Warehouse]: "M115.834 138.468L0.973073 69.4513L116.128 0.699041L231.27 69.4502L115.834 138.468Z",
    },
    inner: {
      [BuildingType.Library]: "M155.271 162.95 L41.4775 99.9697 L195.181 12.5371 L308.977 75.5132 L155.271 162.95Z",
      [BuildingType.Dummy]: "M97.6265 7.92773L12.3665 58.8414L97.6265 109.961L182.9 58.8414L97.6265 7.92773Z",
      [BuildingType.Management]: "M220 60 L139 7 L14 84 L95 136 L220 60 Z",
      [BuildingType.Tracker]: "M8.13 89.76 L113.56 152.27 L178.37 113.73 L72.91 51.23 L8.13 89.76 Z",
      [BuildingType.Monitoring_Reporting]: "M8 100 L179 202 L291 135 L122 33 L8 100 Z",
      [BuildingType.SpaceConfig]: "M274 101 L137 168 L0 101 L137 33 L274 101 Z",
      [BuildingType.Catalog]: "M187 211 L0 101 L187 0 L375 102 L187 211 Z",
      [BuildingType.Marketplace]: "M17 121 L110 177 L295 66 L201 10 L17 121Z",
      [BuildingType.Warehouse]: "M116.129 9.05322L14.7101 69.6153L116.129 130.419L217.561 69.6153L116.129 9.05322Z",
    },
  };

  innerRoofPath = computed(() => this.getRoofPath("inner"));
  outerRoofPath = computed(() => this.getRoofPath("outer"));

  private getRoofPath(type: "inner" | "outer"): string {
    return this.roofPaths[type][this.type()] || "";
  }
}
